import React, {Fragment, useState, useEffect} from 'react';
import RNUFormService from "../../../../services/RNUFormService";
import {CHECK_IMG, UE_LOGO} from "../../../../constants";
import Color from "color";
import {CLEAR_IMG} from "../../../../constants";

const Template1BSynthese = (props) => {

    const rnuFormSrevice = new RNUFormService()
    const [syntheseData, setSyntheseData] = useState([])

    useEffect(()=>{
        setSyntheseData(rnuFormSrevice.checkSyntheseCount())
        //console.log()
    },[])

    return (
        <div className="ue-section ue-synthese">
            <table className="ue-form-table-base ue-form-table-row">
                <thead style={(props.primColor)?{"backgroundColor": Color(props.primColor).alpha(0.5)}:{}}>
                <tr className={"ue-table-row-header"}>
                    <th>Synthèse</th>
                    <th style={{"textAlign":"center", "width":"40px"}}>Impact</th>
                </tr>
                </thead>
                <tbody>
                {syntheseData.map((item, index) => {

                    return(
                        <tr key={index}>
                        <td style={{"borderRight":"none", "borderLeft":"none" }}>{item.label}</td>
                            {
                                (item.nb && item.nb > 0)
                                ? <td className={"ue-coche ue-text-green"} style={{"borderRight":"none","borderLeft":"none","textAlign":"center"}}> <img src={CHECK_IMG} alt="Oui" height="15"/></td>
                                : <td className={"text-center"} style={{"borderRight":"none", "borderLeft":"none","textAlign":"center"}}>-</td>
                            }
                        </tr>
                    )
                })

                }
                </tbody>
            </table>
            <br/>
            {/*
            <p className="text-center">
                <span className="ue-font-weight-7">
                    Ce terrain est soumis aux dispositions du Plan Local d’urbanisme (PLU) approuvé le 19/12/2019.</span><br/>
                Toutefois les dispositions des articles R. 111-3, R. 111-5 à R. 111-19 et R. 111-28 à R. 111-30 ne sont pas applicables dans les territoires dotés d'un plan local d'urbanisme ou d'un document d'urbanisme en tenant lieu. Les termes utilisés par le règlement
                national d'urbanisme peuvent être définis par un lexique national d'urbanisme, pris par arrêté du ministre chargé de l’urbanisme.
            </p>
            */}
        </div>
    );
};

export default Template1BSynthese;
